import { del, get, post } from "../../axios";
import { generateQueryParams } from "./api-contracts";
import { responseIsSuccessful } from "../../global-helpers";
import {
  clearAsyncInterval,
  makeFormData,
  simpleResponse
} from "../api-helpers";

let contractScopeItemsRecheckInterval;

function formatScheduledForArray(item) {
  if (item.scheduled_for) {
    item.scheduled_for = [item.scheduled_for];
    if (item.schedules) {
      item.scheduled_for.push(...item.schedules.map(s => s.scheduled_for));
    }
  }
}

function formatContractScopeItems(scopeItems) {
  scopeItems.map(si => {
    if (
      !Array.isArray(si.work_scope_items) &&
      si.work_scope_items.constructor === Object
    ) {
      si.work_scope_items = Object.values(si.work_scope_items);
    }

    if (si.work_scope_items) {
      si.work_scope_items.map(wsi => {
        formatScheduledForArray(wsi);
        if (wsi.tasks) {
          wsi.tasks.map(t => {
            formatScheduledForArray(t);
            return t;
          });
        }
        return wsi;
      });
    }

    return si;
  });
}

export async function getContractScopeItems(
  contractId,
  unassignedOnly = false
) {
  let queryParams = generateQueryParams(contractId);
  queryParams += unassignedOnly ? "&unassigned=true" : "";
  return await get(
    `work-scope-items/${queryParams}`,
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res)) {
        if (res.data.scope_items) {
          if (contractScopeItemsRecheckInterval) {
            clearAsyncInterval(contractScopeItemsRecheckInterval);
          }
          formatContractScopeItems(res.data.scope_items);
          return res.data.scope_items;
        }

        // if (res.data.pending && !contractScopeItemsRecheckInterval) {
        //   contractScopeItemsRecheckInterval = setAsyncInterval(getContractScopeItems(contractId), 5000);
        // }
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function storeContractScopeItemTask(task) {
  const formData = makeFormData({ task_params: task });
  return simpleResponse(post("tasks", formData, window.localStorage.apiToken));
}

export async function updateContractScopeItem(item) {
  const formData = makeFormData({ item_params: item, _method: "put" });
  return simpleResponse(
    post(
      `workscopeworkscopeitem/${item.work_scope_work_scope_item_id}`,
      formData,
      window.localStorage.apiToken
    )
  );
}

export async function updateContractScopeItemTask(task) {
  const formData = makeFormData({ task_params: task, _method: "put" });
  return simpleResponse(
    post(`tasks/${task.id}`, formData, window.localStorage.apiToken)
  );
}

export async function updateContractScopeItemStatus(item) {
  return simpleResponse(
    post(
      "work-scope-items/mark-as",
      { work_scope_item_params: item },
      window.localStorage.apiToken
    )
  );
}

export async function deleteContractScopeItemTask(task) {
  return simpleResponse(del(`tasks/${task.id}`, window.localStorage.apiToken));
}
